import api from "../api";

/**
 * Busca a listagem de materiais utilizados pelo perfil indicado
 *
 * @param id  id do perfil
 * @param page pagina da listagem de itens
 * @param is_partner é perfil de parceiro?
 * @param is_active ""| "active" | "inactive"
 * @returns nodes para popular a TreeTable
 */
export const getMaterials = async (
	id: number,
	page: number = 1,
	is_partner: boolean = false,
	is_active?: "" | "active" | "inactive"
) => {
	const requestURL = `manager/${
		is_partner ? "partner" : "profile"
	}/${id}/materials`;

	const { data } = await api.get(requestURL, {
		params: {
			page,
			is_active:
				is_active === ""
					? null
					: is_active === "active"
					? "True"
					: "False",
		},
	});

	return data;
};

/**
 * Busca os children nodes de determinado node da TreeTable por demanda
 * @param profile_id id do perfil a quais os itens "pertencem"
 * @param user_type é um parceiro ou outro tipo de conta?
 * @param material_type tipo do material que disparou o evento
 * @param material_id a id do material que estou buscando
 * @returns children nodes do material indicado
 */
export const userMaterialsProductLeaf = async (
	profile_id: number,
	is_partner: boolean = false,
	material_type: string,
	material_id: number
) => {
	const requestURL = `manager/${
		is_partner ? "partner" : "profile"
	}/${profile_id}/materials_leaf`;

	const { data } = await api.get(requestURL, {
		params: { material_type, material_id },
	});

	return data;
};

export const managerUserChangePassword = async (id: number, params: any) => {
	const { data } = await api.put(
		`manager/profile/${id}/update_password/`,
		params
	);

	return data;
};
